import { render, staticRenderFns } from "./ListOrText.vue?vue&type=template&id=8cc45662&scoped=true&"
import script from "./ListOrText.vue?vue&type=script&lang=js&"
export * from "./ListOrText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc45662",
  null
  
)

export default component.exports